import {
  InfoApi,
  PlatformInfo,
  RequestOptions,
} from '@agilelab/plugin-wb-platform';
import { DiscoveryApi, FetchApi } from '@backstage/core-plugin-api';

export class InfoApiClient implements InfoApi {
  private readonly discoveryApi: DiscoveryApi;
  private readonly fetchApi: FetchApi;

  constructor(options: { discoveryApi: DiscoveryApi; fetchApi: FetchApi }) {
    this.discoveryApi = options.discoveryApi;
    this.fetchApi = options.fetchApi;
  }

  async getInfo(options: RequestOptions = {}): Promise<PlatformInfo> {
    const baseUrl = await this.discoveryApi.getBaseUrl('platform');
    const url = `${baseUrl}/info`;
    const headers: Record<string, string> = {};
    if (options.token) {
      headers.authorization = `Bearer ${options.token}`;
    }
    const response = await this.fetchApi.fetch(url, { headers });
    if (!response.ok) {
      throw new Error(`Failed to fetch platform info: ${response.statusText}`);
    }
    return response.json();
  }
}
